import request from '@/utils/request.js'
// 获取appid
export const getAppId = () => {
  return request({
    method: 'POST',
    url: '/api/yalimedia.user/appid'
  })
}
